import { TableProps } from '@cloudscape-design/components/table';
import { bytesToMegabytes } from './bytesConversion';

export interface UsageSummary {
  TerminalId: number;
  TxBytes: number | string;
  RxBytes: number | string;
  TotalBytes: number | string;
  Status: String;
  CompanyName: string;
  TerminalName: string;
  TerminalAltName: string;
  ServicePlan: string;
  ServicePlanUsageBased: string;
  NetworkName: string;
}
export interface UsageSummaryCSV {
  TerminalId: number | string | null;
  TxBytes: number | null;
  RxBytes: number | null;
  TotalBytes: number | null;
  Status: string | null;
  CompanyName: string | null;
  TerminalName: string | null;
  TerminalAltName: string | null;
  ServicePlan: string | null;
  ServicePlanUsageBased: string | null;
  NetworkName: string | null;
}
export interface mapStats {
  TerminalId: number;
  TerminalName: string;
  terminalLat: number | null;
  terminalLon: number | null;
}

export const COLUMNDEFINITIONS: TableProps<UsageSummary>['columnDefinitions'] =
  [
    //todo replace
    {
      id: 'TerminalId',
      header: 'Terminal ID',
      cell: ({ TerminalId }) => 'TI-' + TerminalId.toString().padStart(4, '0'),
      sortingField: 'TerminalId',
      minWidth: 132,
    },
    {
      id: 'TxBytes',
      header: 'Upload (MB)',
      cell: ({ TxBytes, NetworkName }) => {
        if (typeof TxBytes === 'string') {
          return '-';
        }
        return bytesToMegabytes(TxBytes, 4, NetworkName);
      },
      sortingField: 'TxBytes',
      minWidth: 140,
    },
    {
      id: 'RxBytes',
      header: 'Download (MB)',
      cell: ({ RxBytes, NetworkName }) => {
        if (typeof RxBytes === 'string') {
          return '-';
        }
        return bytesToMegabytes(RxBytes, 4, NetworkName);
      },
      sortingField: 'RxBytes',
      minWidth: 160,
    },
    {
      id: 'TotalBytes',
      header: 'Total Usage (MB)',
      cell: ({ TotalBytes, NetworkName }) => {
        if (typeof TotalBytes === 'string') {
          return '-';
        }
        return bytesToMegabytes(TotalBytes, 4, NetworkName);
      },
      sortingField: 'TotalBytes',
      minWidth: 170,
    },
    {
      id: 'Status',
      header: 'Status',
      cell: ({ Status }) => Status,
      sortingField: 'TerminalStatus',
      // width: 160,
    },
    {
      id: 'CompanyName',
      header: 'Owned By',
      cell: ({ CompanyName }) => CompanyName,
      sortingField: 'CompanyName',
      minWidth: 125,
    },
    {
      id: 'TerminalName',
      header: 'Name',
      cell: ({ TerminalName }) => TerminalName,
      sortingField: 'TerminalName',
      minWidth: 220,
    },
    {
      id: 'TerminalAltName',
      header: 'Alt Name',
      cell: ({ TerminalAltName }) => TerminalAltName,
      sortingField: 'TerminalAltName',
      minWidth: 220,
    },
    {
      id: 'ServicePlan',
      header: 'Service Plan',
      cell: ({ ServicePlan }) => ServicePlan,
      sortingField: 'TerminalServicePlan',
      minWidth: 160,
    },
    {
      id: 'ServicePlanUsageBased',
      header: 'Usage Based',
      cell: ({ ServicePlanUsageBased }) => ServicePlanUsageBased,
      sortingField: 'TerminalServicePlanUsageBased',
      minWidth: 145,
    },
    {
      id: 'NetworkName',
      header: 'Network',
      cell: ({ NetworkName }) => NetworkName,
      sortingField: 'NetworkName',
      // width: 180,
    },
  ];
